<p-drawer
	[visible]="visible"
	(visibleChange)="onDrawerVisibleChange($event)"
	position="right"
	class="chat-drawer"
	[showCloseIcon]="false"
	[dismissible]="true">
	<ng-template #headless>
		<div class="chat-panel-wrapper">
		<!-- Header drawer -->
		<div class="chat-panel-header">
			<div class="d-flex align-items-center gap-2">
				<i class="pi pi-comments" aria-hidden="true"></i>
				<span class="chat-panel-title">{{ 'Messaggi' | translate }}</span>
			</div>
			<div class="d-flex align-items-center gap-1">
				<p-button icon="pi pi-plus" [text]="true" [rounded]="true" size="small" severity="primary" pTooltip="{{ newConvLabel | translate }}" (onClick)="openNewConvDialog()"></p-button>
				<p-button icon="pi pi-cog" [text]="true" [rounded]="true" size="small" severity="secondary" pTooltip="{{ 'Impostazioni' | translate }}" (onClick)="openSettingsDialog()"></p-button>
				<p-button icon="pi pi-external-link" [text]="true" [rounded]="true" size="small" severity="secondary" pTooltip="{{ 'Apri a pagina intera' | translate }}" (onClick)="openFullPage()"></p-button>
				<p-button icon="pi pi-times" [text]="true" [rounded]="true" size="small" severity="secondary" pTooltip="{{ 'Chiudi' | translate }}" (onClick)="close()"></p-button>
			</div>
		</div>

		<!-- Split-view -->
		<div class="chat-layout chat-layout--panel" [class.sidebar-open]="sidebarOpen">
			<!-- Pannello conversazioni -->
			<aside class="chat-sidebar">
				<div class="chat-search">
					<i class="pi pi-search" aria-hidden="true"></i>
					<input type="text" class="kcs-inputtext kcs-component chat-search-field" [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange()" placeholder="{{ 'Cerca' | translate }}" />
				</div>

				<div class="chat-recent-label">{{ 'Conversazioni recenti' | translate }}</div>

				@if (loading && conversations.length === 0) {
					<div class="text-center p-3"><i class="pi pi-spin pi-spinner"></i></div>
				}

				@if (!loading && conversations.length === 0) {
					<div class="chat-empty-list">
						<i class="pi pi-comments" aria-hidden="true"></i>
						<p>{{ 'Nessuna conversazione' | translate }}</p>
					</div>
				}

				<div class="chat-conv-list">
					@for (conv of filteredConversations; track conv.conv_id) {
						<button type="button" class="chat-conv-item" [class.active]="isSelected(conv)" (click)="selectConversation(conv)">
							<span class="chat-avatar">{{ getInitials(conv) }}</span>
							<span class="chat-conv-info">
								<span class="chat-conv-name">{{ getOtherName(conv) }} @if (conv.muted) { <i class="pi pi-bell-slash chat-muted-icon" aria-hidden="true"></i> }</span>
								<span class="chat-conv-preview">{{ getPreview(conv) }}</span>
							</span>
							@if (conv.unread_count && conv.unread_count > 0) {
								<span class="chat-conv-badge">{{ conv.unread_count }}</span>
							}
						</button>
					}

					<!-- Ricerca stile WhatsApp: persone con cui non hai ancora una chat -->
					@if (searchTerm.trim() && searchNewUsers.length > 0) {
						<div class="chat-recent-label">{{ 'Nuova chat' | translate }}</div>
						@for (user of searchNewUsers; track user.usr_id) {
							<button type="button" class="chat-conv-item" (click)="startChatWith(user)">
								<span class="chat-avatar">{{ userInitials(user) }}</span>
								<span class="chat-conv-info">
									<span class="chat-conv-name">{{ userLabel(user) }}</span>
									<span class="chat-conv-preview">{{ 'Avvia una nuova chat' | translate }}</span>
								</span>
								<i class="pi pi-comment" aria-hidden="true"></i>
							</button>
						}
					}
				</div>
			</aside>

			<!-- Pannello conversazione attiva -->
			<section class="chat-main">
				@if (!selectedConv) {
					<div class="chat-placeholder">
						<i class="pi pi-comments" aria-hidden="true"></i>
						<p>{{ 'Seleziona una conversazione' | translate }}</p>
					</div>
				} @else {
					<header class="chat-main-header">
						<button type="button" class="chat-menu-toggle" (click)="toggleSidebar()" aria-label="Menu">
							<i class="pi pi-bars" aria-hidden="true"></i>
						</button>
						<span class="chat-avatar chat-avatar--header">{{ getActiveInitials() }}</span>
						<span class="chat-main-name">{{ getOtherName(selectedConv) }}</span>
						<p-button icon="pi pi-ellipsis-v" [text]="true" [rounded]="true" size="small" severity="secondary" (onClick)="convMenu.toggle($event)" pTooltip="{{ 'Opzioni' | translate }}"></p-button>
						<p-menu #convMenu [model]="convMenuItems" [popup]="true" appendTo="body"></p-menu>
					</header>

					<div class="chat-messages" #messagesContainer>
						@if (loadingMessages && messages.length === 0) {
							<div class="text-center p-3"><i class="pi pi-spin pi-spinner"></i></div>
						}

						@if (!loadingMessages && messages.length === 0) {
							<div class="chat-placeholder">
								<i class="pi pi-comments" aria-hidden="true"></i>
								<p>{{ 'Inizia la conversazione!' | translate }}</p>
							</div>
						}

						@for (msg of messages; let i = $index; track msg.msg_id) {
							<div class="chat-msg-row" [class.own]="isOwnMessage(msg)" [class.other]="!isOwnMessage(msg)">
								@if (shouldShowDate(i) && !isOwnMessage(msg)) {
									<span class="chat-msg-date">{{ getMessageDate(msg) }}</span>
								}
								<div class="chat-bubble" [class.deleted]="isDeleted(msg)">
									@if (!isOwnMessage(msg) && isGroup(selectedConv) && !isDeleted(msg)) {
										<span class="chat-msg-sender">{{ getMsgSenderName(msg) }}</span>
									}
									@if (isDeleted(msg)) {
										<span class="chat-msg-deleted"><i class="pi pi-ban" aria-hidden="true"></i> {{ 'Messaggio eliminato' | translate }}</span>
									} @else {
										@if (msg.attachments?.length) {
											<div class="chat-att-wrap">
												@for (att of msg.attachments; track att.att_id) {
													@if (isImage(att) && att._objectUrl) {
														<img [src]="att._objectUrl" class="chat-att-img" (click)="openAttachment(att)" alt="{{ att.att_filename }}" />
													} @else {
														<button type="button" class="chat-att-file" (click)="openAttachment(att)"><i class="pi pi-file" aria-hidden="true"></i> {{ att.att_filename }}</button>
													}
												}
											</div>
										}
										@if (msg.msg_text) { <span class="chat-bubble-text">{{ msg.msg_text }}</span> }
										@if (isEdited(msg)) { <span class="chat-msg-edited">{{ 'modificato' | translate }}</span> }
										@if (isOwnMessage(msg)) {
											<button type="button" class="chat-msg-kebab" (click)="openMsgMenu($event, msg, msgMenu)" aria-label="Azioni"><i class="pi pi-ellipsis-v" aria-hidden="true"></i></button>
										}
									}
								</div>
								@if (shouldShowDate(i) && isOwnMessage(msg)) {
									<span class="chat-msg-date">{{ getMessageDate(msg) }}</span>
								}
							</div>
						}
						<p-menu #msgMenu [model]="msgMenuItems" [popup]="true" appendTo="body"></p-menu>
					</div>

					<div class="chat-input">
						<input #fileInput type="file" multiple (change)="onFilesPicked($event)" style="display: none" />
						<p-button icon="pi pi-paperclip" [text]="true" [rounded]="true" size="small" severity="secondary" [disabled]="sending" (onClick)="triggerFile()" pTooltip="{{ 'Allega' | translate }}"></p-button>
						<input
							type="text"
							class="kcs-inputtext kcs-component chat-input-field"
							[(ngModel)]="newMessageText"
							placeholder="{{ 'Scrivi un messaggio' | translate }}"
							(keydown)="onKeydown($event)" />
						<p-button icon="pi pi-send" [rounded]="true" size="small" severity="primary" [loading]="sending" [disabled]="!newMessageText.trim()" (onClick)="sendMessage()" pTooltip="{{ 'Invia' | translate }}"></p-button>
					</div>
				}
			</section>
		</div>
		</div>
	</ng-template>
</p-drawer>

<!-- Dialog nuova conversazione / nuovo gruppo -->
<p-dialog [header]="(groupMode ? 'Nuovo Gruppo' : 'Nuova Conversazione') | translate" [(visible)]="showNewConvDialog" [modal]="true" [style]="{ width: '420px' }">
	<div class="flex flex-col gap-2">
		<div class="d-flex justify-content-end mb-2">
			<p-button [label]="(groupMode ? 'Chat singola' : 'Crea gruppo') | translate" [icon]="groupMode ? 'pi pi-user' : 'pi pi-users'" size="small" [text]="true" severity="secondary" (onClick)="toggleGroupMode()"></p-button>
		</div>

		@if (!groupMode) {
			@if (canSearchUsers) {
				<label class="kcs-form-label">{{ 'Seleziona utente' | translate }}</label>
				<p-select
					[(ngModel)]="selectedUser"
					[options]="users"
					[optionLabel]="'usr_lastname'"
					[filter]="true"
					filterBy="usr_firstname,usr_lastname,usr_username"
					[showClear]="true"
					[style]="{ width: '100%' }"
					appendTo="body"
					placeholder="{{ 'Cerca utente...' | translate }}"
					(onFilter)="onUserFilter($event)"
					[loading]="searchingUsers">
					<ng-template let-user #item>
						<span>{{ user.usr_lastname }} {{ user.usr_firstname }}</span>
					</ng-template>
					<ng-template let-user #selectedItem>
						<span>{{ user.usr_lastname }} {{ user.usr_firstname }}</span>
					</ng-template>
				</p-select>
			} @else {
				<!-- COMPANY: il lato azienda e' l'insieme dei membri, non c'e' un utente da scegliere -->
				<small class="chat-settings-hint">
					<i class="pi pi-info-circle" aria-hidden="true"></i>
					@if (canWriteToCompany) {
						{{ "In questa azienda la chat è azienda ↔ cliente: puoi scrivere all'azienda, ti rispondono i suoi operatori." | translate }}
					} @else {
						{{ "In questa azienda la chat è azienda ↔ cliente: le conversazioni le aprono i clienti. Per scrivere a un collega crea un gruppo." | translate }}
					}
				</small>
			}
		} @else {
			<label class="kcs-form-label">{{ 'Nome del gruppo' | translate }}</label>
			<input type="text" class="kcs-inputtext kcs-component w-100" [(ngModel)]="groupName" placeholder="{{ 'Nome del gruppo' | translate }}" />
			<label class="kcs-form-label mt-2">{{ 'Membri' | translate }}</label>
			<p-multiselect
				[(ngModel)]="groupSelectedUsers"
				[options]="users"
				optionLabel="usr_lastname"
				[filter]="true"
				filterBy="usr_firstname,usr_lastname,usr_username"
				[style]="{ width: '100%' }"
				appendTo="body"
				placeholder="{{ 'Seleziona membri...' | translate }}"
				(onFilter)="onUserFilter($event)">
				<ng-template let-user #item>
					<span>{{ user.usr_lastname }} {{ user.usr_firstname }}</span>
				</ng-template>
			</p-multiselect>
		}
	</div>
	<ng-template #footer>
		<div class="d-flex justify-content-end gap-2">
			<p-button label="{{ 'Annulla' | translate }}" size="small" severity="secondary" [outlined]="true" (onClick)="showNewConvDialog = false"></p-button>
			@if (!groupMode) {
				@if (canSearchUsers) {
					<p-button label="{{ 'Avvia Chat' | translate }}" size="small" severity="primary" icon="pi pi-comments" [disabled]="!selectedUser" (onClick)="startConversation()"></p-button>
				} @else if (canWriteToCompany) {
					<p-button label="{{ newConvLabel | translate }}" size="small" severity="primary" icon="pi pi-building" (onClick)="startCompanyConversation()"></p-button>
				}
			} @else {
				<p-button label="{{ 'Crea gruppo' | translate }}" size="small" severity="primary" icon="pi pi-users" [disabled]="!groupName.trim() || groupSelectedUsers.length === 0" (onClick)="createGroup()"></p-button>
			}
		</div>
	</ng-template>
</p-dialog>

<!-- Dialog impostazioni chat -->
<p-dialog header="{{ 'Impostazioni chat' | translate }}" [(visible)]="showSettingsDialog" [modal]="true" [style]="{ width: '420px' }">
	<div class="flex flex-col gap-3">
		<div class="d-flex align-items-center justify-content-between gap-3">
			<div>
				<div class="kcs-form-label mb-0">{{ 'Email quando qualcuno ti scrive' | translate }}</div>
				<small class="chat-settings-hint">{{ 'Ricevi una email se arriva un messaggio e la conversazione era inattiva da almeno 1 ora' | translate }}</small>
			</div>
			<p-toggleswitch [(ngModel)]="settings.email_notify"></p-toggleswitch>
		</div>
		<div class="d-flex align-items-center justify-content-between gap-3">
			<div>
				<div class="kcs-form-label mb-0">{{ 'Notifiche del browser' | translate }}</div>
				<small class="chat-settings-hint">{{ 'Mostra una notifica desktop quando arriva un nuovo messaggio' | translate }}</small>
			</div>
			<p-toggleswitch [(ngModel)]="browserNotify"></p-toggleswitch>
		</div>
	</div>
	<ng-template #footer>
		<div class="d-flex justify-content-end gap-2">
			<p-button label="{{ 'Annulla' | translate }}" size="small" severity="secondary" [outlined]="true" (onClick)="showSettingsDialog = false"></p-button>
			<p-button label="{{ 'Salva' | translate }}" size="small" severity="primary" icon="pi pi-save" (onClick)="saveSettings()"></p-button>
		</div>
	</ng-template>
</p-dialog>

<!-- Dialog modifica messaggio -->
<p-dialog header="{{ 'Modifica messaggio' | translate }}" [(visible)]="showEditDialog" [modal]="true" [style]="{ width: '420px' }">
	<textarea class="kcs-inputtext kcs-component w-100" rows="3" [(ngModel)]="editingText"></textarea>
	<ng-template #footer>
		<div class="d-flex justify-content-end gap-2">
			<p-button label="{{ 'Annulla' | translate }}" size="small" severity="secondary" [outlined]="true" (onClick)="showEditDialog = false"></p-button>
			<p-button label="{{ 'Salva' | translate }}" size="small" severity="primary" icon="pi pi-save" [disabled]="!editingText.trim()" (onClick)="saveEdit()"></p-button>
		</div>
	</ng-template>
</p-dialog>

<!-- Dialog gestione gruppo -->
<p-dialog header="{{ 'Gestione gruppo' | translate }}" [(visible)]="showGroupDialog" [modal]="true" [style]="{ width: '440px' }">
	<div class="d-flex gap-2 mb-3">
		@if (isGroupAdmin) {
			<p-button label="{{ 'Rinomina' | translate }}" size="small" icon="pi pi-pencil" [outlined]="true" severity="secondary" (onClick)="renameGroup()"></p-button>
		}
		<p-button label="{{ 'Abbandona' | translate }}" size="small" icon="pi pi-sign-out" [outlined]="true" severity="danger" (onClick)="leaveGroup()"></p-button>
	</div>

	<h6 class="titolo-card">{{ 'Membri' | translate }} ({{ groupMembers.length }})</h6>
	<div class="flex flex-col gap-1 mb-3">
		@for (m of groupMembers; track m.cvm_usr_id) {
			<div class="d-flex align-items-center justify-content-between" style="padding: 4px 0;">
				<span>{{ memberName(m) }} @if (m.cvm_role === 'ADMIN') { <small>(admin)</small> }</span>
				@if (isGroupAdmin && m.cvm_usr_id !== currentUserId) {
					<p-button icon="pi pi-user-minus" [text]="true" [rounded]="true" size="small" severity="danger" (onClick)="removeGroupMember(m)" pTooltip="{{ 'Rimuovi' | translate }}"></p-button>
				}
			</div>
		}
	</div>

	@if (isGroupAdmin) {
		<label class="kcs-form-label">{{ 'Aggiungi membro' | translate }}</label>
		<div class="d-flex gap-2">
			<p-select
				[(ngModel)]="groupAddSelected"
				[options]="groupAddUsers"
				optionLabel="usr_lastname"
				[filter]="true"
				filterBy="usr_firstname,usr_lastname,usr_username"
				[showClear]="true"
				[style]="{ width: '100%' }"
				appendTo="body"
				placeholder="{{ 'Cerca persona...' | translate }}"
				(onFilter)="onGroupAddFilter($event)">
				<ng-template let-user #item><span>{{ user.usr_lastname }} {{ user.usr_firstname }}</span></ng-template>
				<ng-template let-user #selectedItem><span>{{ user.usr_lastname }} {{ user.usr_firstname }}</span></ng-template>
			</p-select>
			<p-button icon="pi pi-plus" size="small" severity="primary" [disabled]="!groupAddSelected" (onClick)="addGroupMember()"></p-button>
		</div>
	}
	<ng-template #footer>
		<div class="d-flex justify-content-end">
			<p-button label="{{ 'Chiudi' | translate }}" size="small" severity="secondary" [outlined]="true" (onClick)="showGroupDialog = false"></p-button>
		</div>
	</ng-template>
</p-dialog>
